// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { Switch, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { detectIE } from 'common/utils/detect-ie';
import { ROOT_ROUTE, PREVIEW_ROUTE } from 'client/constants';
import type { Store } from 'client/reducers';
import { PopUpManager } from 'client/components/common';
import ProgressSplash from 'common/components/ProgressSplash';
import Intro from 'client/components/Intro';
import withParentWindowAutoHeight from 'client/components/common/withParentWindowAutoHeight';

import * as css from './App.scss';

type Props = {
	isBusy?: boolean,
	item: ClientItem,
};

class App extends React.PureComponent<Props> {
	static defaultProps = {
		isBusy: false,
	};

	componentDidMount() {
		const isIE = detectIE();

		if (document && document.body) {
			document.body.setAttribute('data-browser', isIE ? 'ie' : 'not-ie');
		}
	}

	render() {
		const { item, isBusy } = this.props;

		return (
			<div id="app" className={css.app}>
				<Helmet
					title="TV Bee"
					meta={[
						{ name: 'description', content: 'TV Bee' },
						{ property: 'og:title', content: 'TV Bee og:content' },
					]}
				/>
				<div className={css.content}>
					<Switch>
						<Route path={PREVIEW_ROUTE} component={Intro} />
						<Route path={ROOT_ROUTE} component={Intro} />
					</Switch>
					<PopUpManager />
					<ProgressSplash mode="client" isBusy={isBusy} className={css.clientPreloader} />
				</div>
				<div className={css.footer}>
					{item.data && (
						<div className={css.footerLinkWrap}>
							<span>אהבתם את</span>
							<span className={css.footerLinkBold}>{item.data.nameHebrew || item.data.name}</span>
							<span>? היכנסו לבחור את הסדרה הבאה שלכם!</span>
							<a
								href="https://myseries.mako.co.il/?tvbee_component"
								target="_blank"
								rel="noopener noreferrer"
							>
								מה רואים היום
							</a>
						</div>
					)}
				</div>
			</div>
		);
	}
}

const mapState = (state: Store): Props => ({
	isBusy: state.item.isBusy,
	item: state.item,
});

const mapDispatch = (dispatch: Dispatch<{ type: string }>) => ({});

export default (connect(mapState, mapDispatch)(withParentWindowAutoHeight(App)): React.AbstractComponent<{}>);
